export const de = {
  // Navigation
  navigation: {
    singleVerification: 'Einzelverifizierung',
    batchVerification: 'Stapelverifizierung',
    about: 'Über',
    logout: 'Abmelden'
  },
  auth: {
    emailVerification: {
      title: 'E-Mail Verifizieren',
      message: 'Wir haben eine Verifizierungs-E-Mail an {email} gesendet. Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Verifizierungslink, um Ihr Konto zu aktivieren.',
      checkEmail: 'Überprüfen Sie Ihre E-Mail',
      followInstructions: 'Befolgen Sie die Anweisungen in der E-Mail, um Ihr Konto zu verifizieren.',
      resendEmail: 'Verifizierungs-E-Mail Erneut Senden',
      sending: 'Wird gesendet...',
      backToLogin: 'Zurück zur Anmeldung',
      emailSent: 'Verifizierungs-E-Mail erfolgreich gesendet!',
      helpText: 'Wenn Sie die E-Mail nicht in Ihrem Posteingang sehen, überprüfen Sie bitte Ihren Spam-Ordner.'
    }
  },

  // Header
  header: {
    title: 'Peppol USt-Verifizierung',
    subtitle: 'EU USt & Peppol Verifizierungs-Tool'
  },

  // Footer
  footer: {
    description: 'Peppol USt-Verifizierungs-Tool - Erstellt mit React & TypeScript',
    disclaimer: 'Nur zu Demonstrationszwecken. Produktionsnutzung erfordert ordnungsgemäße API-Integration.',
    termsOfUse: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie'
  },

  // About Page
  about: {
    title: 'Über Peppol USt-Verifizierung',
    overview: {
      title: 'Überblick',
      content: 'Diese Anwendung bietet Verifizierungsdienste für EU-USt-Nummern und Peppol-Teilnehmer-IDs. Sie unterstützt sowohl die Einzelunternehmensverifizierung als auch die Stapelverarbeitung für mehrere Einträge.'
    },
    features: {
      title: 'Funktionen',
      items: [
        { label: 'EU USt-Verifizierung:', description: 'Validiere USt-Nummern mit dem VIES-System (USt-Informationsaustauschsystem)' },
        { label: 'Peppol-Verifizierung:', description: 'Überprüfe Teilnehmer-IDs gegen das Peppol-Verzeichnis' },
        { label: 'Doppelverifizierung:', description: 'Führe sowohl USt- als auch Peppol-Verifizierung mit einer einzigen Kennung durch' },
        { label: 'Einzelverifizierung:', description: 'Verifiziere einzelne Unternehmen mit detaillierten Ergebnissen' },
        { label: 'Stapelverarbeitung:', description: 'Lade CSV-Dateien für Massenverifizierung hoch' },
        { label: 'Echte API-Integration:', description: 'Wechsle zwischen echten API-Aufrufen und Simulationsmodus' },
        { label: 'Exportiere Ergebnisse:', description: 'Lade Verifizierungsergebnisse als CSV-Dateien herunter' },
        { label: 'Vorlagen-Downloads:', description: 'Erhalte CSV-Vorlagen für ordnungsgemäße Datenformatierung' }
      ]
    },
    vatFormats: {
      title: 'Unterstützte USt-Nummer-Formate',
      description: 'Die Anwendung unterstützt USt-Nummern aus allen EU-Mitgliedstaaten:',
      examples: [
        'Österreich: U12345678',
        'Belgien: 1234567890',
        'Deutschland: 123456789',
        'Frankreich: AB123456789',
        'Italien: 12345678901',
        'Niederlande: 123456789B01',
        'Spanien: A12345678',
        'Und viele mehr...'
      ]
    },
    peppolTypes: {
      title: 'Peppol-Teilnehmer-ID-Typen',
      items: [
        { type: 'DUNS:', description: '9-stelliges Data Universal Numbering System' },
        { type: 'GLN:', description: '12-15-stellige Global Location Number' },
        { type: 'USt:', description: 'Ländercode + USt-Nummer' },
        { type: 'Benutzerdefiniert:', description: 'Organisationsspezifische Kennungen' }
      ]
    },
    apiMode: {
      title: 'API-Modus-Umschalter',
      description: 'Die Anwendung enthält einen Umschalter zur Auswahl zwischen:',
      items: [
        { mode: 'Simulationsmodus:', description: 'Verwendet Mock-Daten zu Demonstrationszwecken' },
        { mode: 'Echter API-Modus:', description: 'Macht echte Aufrufe an VIES- und Peppol-APIs' }
      ]
    },
    importantNotes: {
      title: 'Wichtige Hinweise',
      items: [
        'Echter API-Modus erfordert ordnungsgemäßen Netzwerkzugang zu VIES- und Peppol-Diensten',
        'Einige APIs können Ratenbegrenzungen haben oder Authentifizierung erfordern',
        'Simulationsmodus wird für Tests und Demonstrationen empfohlen',
        'Produktionsnutzung sollte ordnungsgemäße Fehlerbehandlung und Wiederholungslogik enthalten'
      ]
    },
    technicalDetails: {
      title: 'Technische Details',
      content: 'Erstellt mit React, TypeScript und Tailwind CSS. Verwendet Papa Parse für CSV-Verarbeitung und enthält umfassende Fehlerbehandlung und Benutzerfeedback.'
    }
  },

  // Terms of Use
  termsOfUse: {
    title: 'Nutzungsbedingungen – vateu.eu',
    sections: {
      scope: {
        title: '1. Umfang und Beta-Status',
        content: 'Der Dienst wird kostenlos nur zu Evaluationszwecken bereitgestellt. Er wird derzeit ausgewählten Testern, einschließlich Shell, angeboten, um Qualität und Wirksamkeit vor einer möglichen kommerziellen Veröffentlichung zu bewerten. Keine Produktionsnutzung wird empfohlen. Der Dienst kann jederzeit ohne Vorankündigung geändert, ausgesetzt oder eingestellt werden.'
      },
      dataSources: {
        title: '2. Datenquellen',
        content: 'USt-Validierungen werden mit dem VIES-System der EU-Kommission und verbundenen nationalen Datenbanken durchgeführt. Peppol-Validierungen basieren auf öffentlichen Peppol-Verzeichnis-/SMP-Quellen. Wir sind nicht mit der Europäischen Kommission, einer nationalen Steuerbehörde oder OpenPeppol verbunden.'
      },
      accuracy: {
        title: '3. Genauigkeit und Verfügbarkeit',
        content: 'Informationen können aufgrund von Ausfallzeiten von Drittanbietersystemen verzögert, unvollständig oder nicht verfügbar sein. Der Dienst wird "wie besehen" bereitgestellt, ohne Gewährleistungen jeglicher Art. Aus Validierungsergebnissen können keine Rechte oder Verpflichtungen abgeleitet werden.'
      },
      acceptableUse: {
        title: '4. Zulässige Nutzung',
        content: 'Benutzer dürfen den Dienst nicht durch übermäßige automatisierte Anfragen missbrauchen. Bulk-Abfragen unterliegen Ratenbegrenzungen und können blockiert werden. Der Dienst darf nicht für rechtswidrige Zwecke verwendet werden.'
      },
      intellectualProperty: {
        title: '5. Geistiges Eigentum',
        content: 'Der Inhalt, Code und das Design von vateu.eu gehören Mariusz Pietruszka (PL6572490600). "VIES" und "Peppol" sind Namen von Dritten; wir beanspruchen keine Rechte daran und verwenden sie nur beschreibend. Verwende das EU-Emblem oder Peppol-Logos nicht in Verbindung mit diesem Dienst.'
      },
      privacy: {
        title: '6. Datenschutz und Datenverarbeitung',
        content: 'Der Dienst speichert nicht dauerhaft USt-Nummern, Peppol-Kennungen oder Validierungsergebnisse, die von Benutzern eingereicht werden. Eingabedaten werden nur an relevante Drittanbieter-Validierungssysteme (z.B. VIES, Peppol-Verzeichnis) übertragen und nur verarbeitet, um das Validierungsergebnis zu generieren, das Ihnen angezeigt wird. Nach der Rückgabe des Ergebnisses wird keine Kopie der Eingabedaten oder Validierungsausgabe in unserem System aufbewahrt, außer für kurzfristige technische Protokolle (siehe Datenschutzrichtlinie).'
      },
      liability: {
        title: '7. Haftung',
        content: 'Im gesetzlich zulässigen Umfang lehnen wir alle Gewährleistungen, ausdrückliche oder stillschweigende, ab. Wir übernehmen keine Haftung für direkte, indirekte oder Folgeschäden, die aus der Nutzung des Dienstes resultieren.'
      },
      changes: {
        title: '8. Änderungen',
        content: 'Wir können diese Bedingungen jederzeit aktualisieren. Die fortgesetzte Nutzung stellt die Annahme der überarbeiteten Bedingungen dar.'
      },
      governingLaw: {
        title: '9. Anwendbares Recht',
        content: 'Diese Bedingungen werden durch die Gesetze Polens geregelt. Alle Streitigkeiten unterliegen der ausschließlichen Gerichtsbarkeit der Gerichte Polens.',
        contact: 'Kontakt: Mariusz Pietruszka – PL6572490600'
      }
    }
  },

  // Privacy Policy
  privacyPolicy: {
    title: 'Datenschutzrichtlinie – vateu.eu',
    effectiveDate: 'Gültigkeitsdatum: 14/09/2025',
    sections: {
      controller: {
        title: '1. Verantwortlicher',
        content: 'Der Dienst wird betrieben von: [Ihr Firmenname, eingetragene Adresse, Kontakt-E-Mail] Für Datenschutzanfragen kontaktieren: [privacy@vateu.eu].'
      },
      dataWeProcess: {
        title: '2. Daten, die wir verarbeiten',
        inputData: 'Eingabedaten: USt-Nummern und Peppol-Kennungen, die Sie zur Validierung einreichen, werden nur im Speicher verarbeitet und an VIES oder das Peppol-Verzeichnis übertragen. Wir speichern diese Kennungen oder Validierungsergebnisse nicht.',
        logs: 'Protokolle: minimale technische Daten (IP-Adresse, Browsertyp, Zeitstempel, Fehlerprotokolle) können gesammelt werden, um Sicherheit zu gewährleisten und Probleme zu beheben.',
        optionalContact: 'Optionaler Kontakt: Wenn Sie uns per E-Mail oder Formular kontaktieren, verarbeiten wir Ihre Kontaktdaten und Nachricht.'
      },
      purposeAndLegalBasis: {
        title: '3. Zweck und Rechtsgrundlage',
        items: [
          'Um Validierungsergebnisse bereitzustellen (unser berechtigtes Interesse, Art. 6(1)(f) DSGVO).',
          'Um Missbrauch zu verhindern und Systemstabilität zu gewährleisten (berechtigtes Interesse).',
          'Um mit Ihnen zu kommunizieren, wenn Sie uns kontaktieren (Vertragserfüllung, Art. 6(1)(b) DSGVO).'
        ]
      },
      dataRetention: {
        title: '4. Datenspeicherung',
        items: [
          'USt-/Peppol-IDs und Validierungsergebnisse werden nach Abschluss des Validierungsanfrage nicht gespeichert.',
          'Protokolle werden maximal [z.B. 30 Tage] aufbewahrt und dann gelöscht oder anonymisiert.',
          'Kontaktdaten werden so lange aufbewahrt, wie es zur Beantwortung Ihrer Anfrage erforderlich ist.'
        ]
      },
      dataSharing: {
        title: '5. Datenweitergabe',
        items: [
          'Validierungsanfragen werden an VIES- (Europäische Kommission) und/oder Peppol-Verzeichnissysteme übertragen.',
          'Wir verkaufen oder teilen keine personenbezogenen Daten mit Dritten zu Marketingzwecken.',
          'Hosting- und Infrastruktur-Anbieter können Daten in unserem Auftrag unter Datenverarbeitungsvereinbarungen verarbeiten.'
        ]
      },
      internationalTransfers: {
        title: '6. Internationale Übertragungen',
        content: 'Daten können auf Servern verarbeitet werden, die in der EU/EWR gelegen sind. Wenn Übertragungen außerhalb der EU/EWR stattfinden, stellen wir angemessene Schutzmaßnahmen sicher (z.B. Standardvertragsklauseln).'
      },
      yourRights: {
        title: '7. Ihre Rechte',
        description: 'Sie haben Rechte unter der DSGVO, einschließlich:',
        items: [
          'Zugang zu Ihren Daten',
          'Berichtigung oder Löschung',
          'Einschränkung oder Widerspruch gegen die Verarbeitung',
          'Datenübertragbarkeit',
          'Beschwerde bei Ihrer Aufsichtsbehörde einreichen'
        ]
      },
      cookiesAnalytics: {
        title: '8. Cookies & Analytics',
        content: 'Wir verwenden nur wesentliche Cookies für die Dienstfunktionalität. Wenn wir Analytics oder nicht wesentliche Cookies einführen, werden wir um Zustimmung bitten.'
      },
      changes: {
        title: '9. Änderungen',
        content: 'Wir können diese Datenschutzrichtlinie aktualisieren. Die neueste Version wird immer auf der Website verfügbar sein.'
      },
      contact: {
        title: '10. Kontakt',
        content: 'Für Fragen oder Anfragen bezüglich dieser Datenschutzrichtlinie, E-Mail [privacy@vateu.eu].'
      }
    }
  },

  // Single Verification
  singleVerification: {
    title: 'Einzelverifizierung',
    verificationType: 'Verifizierungstyp',
    types: {
      vat: 'EU USt-Verifizierung',
      peppol: 'Peppol-Verifizierung',
      both: 'Beide Verifizierungen'
    },
    forms: {
      vatNumber: 'USt-Nummer',
      vatNumberPlaceholder: 'z.B. DE123456789',
      peppolId: 'Peppol-Teilnehmer-ID',
      peppolIdPlaceholder: 'z.B. 123456789 (DUNS) oder 1234567890123 (GLN)',
      peppolIdHelp: 'Geben Sie eine DUNS-Nummer, GLN, USt-Nummer oder benutzerdefinierte Teilnehmer-ID ein',
      companyIdentifier: 'Unternehmensidentifikation',
      companyIdentifierPlaceholder: 'z.B. DE123456789, 123456789, oder 1234567890123',
      companyIdentifierHelp: 'Geben Sie eine USt-Nummer (DE123456789), DUNS (123456789), GLN (1234567890123), oder andere Identifikation ein',
      unifiedTitle: 'Einheitliche Verifizierung',
      unifiedDescription: 'Geben Sie eine einzige Identifikation ein, die für sowohl USt- als auch Peppol-Verifizierung verwendet wird. Dies kann eine USt-Nummer, DUNS, GLN oder andere Unternehmensidentifikation sein.'
    },
    buttons: {
      verify: 'Verifizieren',
      verifying: 'Verifizierung...',
      reset: 'Zurücksetzen'
    },
    apiMode: {
      simulationMode: 'Simulationsmodus',
      realAPI: 'Echte API',
      simulation: 'Simulation'
    },
    results: {
      verificationSuccessful: 'Verifizierung Erfolgreich',
      verificationFailed: 'Verifizierung Fehlgeschlagen',
      verificationResults: 'Verifizierungsergebnisse',
      vatVerification: 'USt-Verifizierung',
      peppolVerification: 'Peppol-Verifizierung',
      fields: {
        vatNumber: 'USt-Nummer',
        companyName: 'Unternehmensname',
        address: 'Adresse',
        fullParticipantId: 'Vollständige Teilnehmer-ID',
        participantName: 'Teilnehmername',
        participantId: 'Teilnehmer-ID',
        scheme: 'Schema',
        supportedDocumentTypes: 'Unterstützte Dokumenttypen',
        supportsBilling: 'Unterstützt Abrechnung',
        error: 'Fehler',
        verifiedAt: 'Verifiziert um',
        yes: 'Ja',
        no: 'Nein'
      },
      multipleMatches: {
        title: 'Mehrere Übereinstimmungen Gefunden',
        matchCount: 'Übereinstimmungen',
        match: 'Übereinstimmung'
      }
    }
  },

  // Batch Verification
  batchVerification: {
    title: 'Stapelverifizierung',
    inputMethod: 'Eingabemethode',
    methods: {
      csv: 'CSV-Upload',
      textarea: 'Texteingabe'
    },
    forms: {
      uploadFile: 'CSV-Datei Hochladen',
      downloadTemplate: 'CSV-Vorlage Herunterladen',
      textAreaPlaceholder: 'Geben Sie Identifikationen getrennt durch Kommas oder neue Zeilen ein (z.B. DE123456789, 123456789, 1234567890123)',
      textAreaHelp: 'Geben Sie eine oder mehrere Identifikationen pro Zeile ein. Trennen Sie mehrere Identifikationen in derselben Zeile mit Kommas.',
      textInputTitle: 'Für Texteingabe geben Sie Identifikationen getrennt durch Kommas ein:',
      textInputDescription: 'Geben Sie Identifikationen getrennt durch Kommas ein. Jede Zeile kann mehrere Identifikationen enthalten. Unterstützt USt-Nummern, DUNS, GLN und andere Unternehmensidentifikationen.',
      textInputRules: [
        'Jede Zeile kann mehrere Identifikationen getrennt durch Kommas enthalten',
        'Unterstützt USt-Nummern (DE123456789), DUNS (123456789), GLN (1234567890123)',
        'Leere Zeilen werden ignoriert',
        'Leerzeichen um Identifikationen werden automatisch entfernt'
      ],
      dualVerificationHelp: 'Die Identifikation kann eine USt-Nummer, DUNS, GLN oder andere Unternehmensidentifikation sein, die für sowohl USt- als auch Peppol-Verifizierung funktioniert.',
      identifiersReady: 'Identifikationen bereit für Verifizierung',
      exportResults: 'Ergebnisse exportieren',
      textInputPlaceholder: 'Identifikationen durch Kommas getrennt eingeben. Jede Zeile kann mehrere Identifikationen enthalten:\n\nDE123456789, FR12345678901\n123456789, 987654321\n1234567890123',
      textInputHelp: 'Identifikationen durch Kommas getrennt eingeben. Jede Zeile kann mehrere Identifikationen enthalten. Unterstützt USt-Nummern, DUNS, GLN und andere Unternehmensidentifikationen.'
    },
    buttons: {
      process: 'Verifizierung Verarbeiten',
      processing: 'Verarbeitung...',
      downloadResults: 'Ergebnisse Herunterladen',
      reset: 'Zurücksetzen',
      cancel: 'Abbrechen'
    },
    results: {
      summary: 'Verifizierungszusammenfassung',
      totalProcessed: 'Gesamt Verarbeitet',
      valid: 'Gültig',
      invalid: 'Ungültig',
      errors: 'Fehler',
      processingTime: 'Verarbeitungszeit',
      noResults: 'Keine Ergebnisse anzuzeigen',
      exportResults: 'Ergebnisse Exportieren',
      vatVerification: 'USt-Verifizierung',
      dualVerificationResults: 'Duale Verifizierungsergebnisse'
    },
    progress: {
      processing: 'Verifizierung wird verarbeitet...',
      completed: 'Verarbeitung abgeschlossen'
    },
    format: {
      csvRequirements: 'CSV-Format-Anforderungen',
      textInputFormat: 'Texteingabe-Format',
      dualVerificationTitle: 'Für duale Verifizierung fügen Sie diese Spalten hinzu:',
      dualVerificationColumns: [
        'identifier oder id - Unternehmensidentifikation (erforderlich)',
        'Alternative Spaltennamen: vatNumber, vat, taxId, participantId, peppolId'
      ],
      vatVerificationTitle: 'Für USt-Verifizierung fügen Sie diese Spalten hinzu:',
      vatVerificationColumns: [
        'vatNumber oder vat oder taxId - USt-Nummer (erforderlich)'
      ],
      peppolVerificationTitle: 'Für Peppol-Verifizierung fügen Sie diese Spalten hinzu:',
      peppolVerificationColumns: [
        'participantId oder peppolId oder id - Teilnehmer-ID (erforderlich)'
      ]
    }
  },

  // Error Messages
  errors: {
    general: {
      unknownError: 'Unbekannter Fehler aufgetreten',
      networkError: 'Netzwerkfehler aufgetreten',
      parsingError: 'Fehler beim Analysieren der CSV-Datei. Bitte überprüfen Sie das Format.',
      noDataToProcess: 'Bitte laden Sie eine CSV-Datei hoch oder geben Sie Identifikationen in das Textfeld ein.',
      invalidInput: 'Ungültige Eingabe bereitgestellt'
    },
    vat: {
      invalidFormat: 'Ungültiges USt-Nummer-Format',
      countryNotSupported: 'Land wird von VIES nicht unterstützt',
      serviceUnavailable: 'VIES-Service ist derzeit nicht verfügbar',
      timeout: 'Anfrage-Timeout - VIES-Service kann langsam sein',
      rateLimit: 'Rate-Limit überschritten - bitte versuchen Sie es später erneut'
    },
    peppol: {
      invalidFormat: 'Ungültiges Peppol-Teilnehmer-ID-Format',
      serviceUnavailable: 'Peppol-Service ist derzeit nicht verfügbar',
      timeout: 'Anfrage-Timeout - Peppol-Service kann langsam sein',
      notFound: 'Teilnehmer nicht im Peppol-Verzeichnis gefunden',
      rateLimit: 'Rate-Limit überschritten - bitte versuchen Sie es später erneut'
    },
    serviceUnavailable: {
      title: 'Service Nicht Verfügbar',
      message: 'Der {service} Service ist derzeit aufgrund hoher Nachfrage oder Wartungsarbeiten nicht verfügbar. Wir werden Ihre Anfrage automatisch wiederholen.',
      autoRetryIn: 'Automatischer Wiederholungsversuch in:',
      retryNow: 'Jetzt Wiederholen',
      cancel: 'Abbrechen',
      helpText: 'Sie können manuell wiederholen oder auf den automatischen Wiederholungsversuch warten. Der Service wird so schnell wie möglich wiederhergestellt.'
    }
  }
};
